export const DOCTOR_END_MEET = "doctor/end-meeting";
export const DOCTOR_UPLOAD_PRESCRIPTION_REV1 =
  "doctor/upload-prescription-rev1";
export const DOCTOR_CHECK_EXTEND = "doctor/check-extend";
export const USER_ENGAGEMENT_ANALYTICS_DATA = "user/engagement-analytics-data";
export const USER_START_MEETING = "user/start-meeting";
export const USER_PRESCRIPTION_HISTORY = "/user/prescription-history";
export const DOCTOR_VIEW_PATIENT_INFO = "/doctor/view-patient-info";
export const DOCTOR_UPDATE_PRESCRIPTION = "doctor/update-prescription";
export const USER_GET_DOCUMENT_REV1 = "user/get-document-rev1";
export const DOCTOR_GET_RECEIVER_DOCUMENT = "doctor/get-receiver-document";
export const DOCTOR_EXTEND_APPOINTMENT = "doctor/extend-appointment";
export const DOCTOR_RESCHEDULE_APPOINTMENT = "/doctor/reschedule-appointment";
export const PUBLIC_CANCEL_APPOINTMENT_REQUEST =
  "/public/cancel-appointment-request";
